// Data.ts

// Definição dos tipos para as chaves permitidas
type DataPageKey = 'index' | 'projects' | 'clients' | 'administrators' | 'updates' | 'reports';

// Tipo para as callbacks registradas
type NotifyCallback<T> = (data: T) => void;

// Interface para a estrutura de dados da página
interface IDataPage {
    index?          : any,
    projects?       : any,
    clients?        : any,
    administrators? : any,
    updates?        : any,
    reports?        : any,
}

// Interface para os callbacks de notificação
interface INotifyDataPage {
    index          : NotifyCallback<any>[];
    projects       : NotifyCallback<any>[];
    clients        : NotifyCallback<any>[];
    administrators : NotifyCallback<any>[];
    updates        : NotifyCallback<any>[];
    reports        : NotifyCallback<any>[];
}

let DataPage: IDataPage = {
    index          : undefined,
    projects       : undefined,
    clients        : undefined,
    administrators : undefined,
    updates        : undefined,
    reports        : undefined,
};

let NotifyDataPage: INotifyDataPage = {
    index          : [],
    projects       : [],
    clients        : [],
    administrators : [],
    updates        : [],
    reports        : [],
};

export function SetListData(value: IDataPage): void {
    DataPage = value;
    NotifyDataPage.index.forEach(element => { 
        element(value.index); 
    });
    NotifyDataPage.projects.forEach(element => { 
        element(value.projects); 
    });
    NotifyDataPage.clients.forEach(element => { 
        element(value.clients); 
    });
    NotifyDataPage.administrators.forEach(element => { 
        element(value.administrators); 
    });
    NotifyDataPage.updates.forEach(element => { 
        element(value.updates); 
    });
    NotifyDataPage.reports.forEach(element => { 
        element(value.reports); 
    });
}

export function SetListDataSingle(key: DataPageKey, value: any): void {
    DataPage[key] = value;
    NotifyDataPage[key].forEach(element => {
        element(value);
    });
}

export function SetListDataSingleItem(key: DataPageKey, id: string | number, value: any): void {
    // precisa ser um objeto novo. Se alterar o atual e notificar com a mesma
    // referência, o useState do componente entende que nada mudou e não
    // renderiza de novo (input controlado fica travado)
    DataPage[key] = { ...(DataPage[key] || {}), [id]: value };
    NotifyDataPage[key].forEach(element => {
        element(DataPage[key]);
    });
}

export function GetDataPage(key: DataPageKey): any {
    return DataPage[key];
}

export function RegisterDataPage(key: DataPageKey, callback: NotifyCallback<any>): void {
    if (!NotifyDataPage[key]) {
        NotifyDataPage[key] = [];
    }
    NotifyDataPage[key].push(callback);
}

export function UnRegisterDataPage(key: DataPageKey, callback: NotifyCallback<any>): void {
    if (NotifyDataPage[key] && NotifyDataPage[key].length > 0) {
        NotifyDataPage[key] = NotifyDataPage[key].filter((item) => {
            return item !== callback;
        });
    }
}